import { useState } from 'react';
import {
  deactivateGeofence,
  deleteGeofence,
  getGeofencesAction
} from '../../../redux/reducer/yaantracSlices/geofenceSlice';
import {
  map,
  updateZoom
} from '../../../../../common/redux/reducer/commonSlices/mapSlice';
import { updatePolygonFenceById } from '../../../../../common/redux/reducer/commonSlices/polygonSlice';
import { updateFenceById } from '../../../../../common/redux/reducer/commonSlices/circleSlice';
import { updateCenter as updateMapCenter } from '../../../../../common/redux/reducer/commonSlices/mapSlice';

export const useGeofenceDeactivate = ({
  setFilteredRow,
  dispatch,
  filteredRow,
  createAbort,
  resetField,
  setCardOpen
}: any) => {
  const [isActivate, setIsActivate] = useState<boolean>(false);

  const handleDeactivate = async (params: any) => {
    setFilteredRow(params);
    setIsActivate(true);
  };

  const handleDeactivateGeofence = async () => {
    let action1 = await dispatch(deactivateGeofence(filteredRow?.geoZoneId));
    if (deactivateGeofence.fulfilled.match(action1)) {
      setCardOpen(false);
      resetField('searchFilter');
      setIsActivate(false);
      setFilteredRow(null);
      await dispatch(getGeofencesAction({ signal: createAbort().abortCall.signal }));
    }
  };
  return { handleDeactivate, handleDeactivateGeofence, setIsActivate, isActivate };
};

export const useGeofenceDelete = ({
  setFilteredRow,
  dispatch,
  filteredRow,
  createAbort,
  setCardOpen,
  resetField
}: any) => {
  const [isDelete, setIsDelete] = useState<boolean>(false);

  const handleDelete = async (params: any) => {
    setFilteredRow(params);
    setIsDelete(true);
  };

  const deleteClose = () => {
    setIsDelete(false);
  };

  const handleGeofenceDelete = async (e: any) => {
    let action2 = await dispatch(deleteGeofence(filteredRow?.geoZoneId));
    if (deleteGeofence.fulfilled.match(action2)) {
      setCardOpen(false);
      setIsDelete(false);
      setFilteredRow(null);
      resetField('searchFilter');
      dispatch(map([]));
      await dispatch(getGeofencesAction({ signal: createAbort().abortCall.signal }));
    }
  };
  return { setIsDelete, isDelete, handleDelete, deleteClose, handleGeofenceDelete };
};

export const useGeofenceUpdate = ({
  dispatch,
  setIsCircular,
  data,
  setFilteredRow,
  setRow,
  setIsOpen,
  setCardOpen
}: any) => {
  const [isUpdate, setIsUpdate] = useState<boolean>(false);

  const onUpdate = (params: any) => {
    setIsCircular(params?.geoType === 'circular');
    setIsUpdate(true);
    if (params?.geoType === 'polygon') {
      const [newFence] = data.filter((item: any) => item?.id === params?.id);
      dispatch(
        updatePolygonFenceById({
          id: params?.geoZoneId,
          paths: newFence?.latAndLongDetails
        })
      );
    } else if (params?.geoType === 'circular') {
      dispatch(
        updateFenceById({
          id: params?.geoZoneId,
          center: params?.latAndLongDetails?.[0],
          radius: params?.radius * 1000
        })
      );
    }
    const polygonLocations = data
      ?.filter((item: any) => item?.geoType === 'polygon')
      ?.map((item: any) => item?.latAndLongDetails || []);
    const circularLocations = data
      ?.filter((item: any) => item?.geoType === 'circular')
      ?.map((item: any) => item?.latAndLongDetails?.[0] || []);
    if (polygonLocations?.length > 0 || circularLocations?.length > 0) {
      dispatch(updateMapCenter([polygonLocations?.flat(), circularLocations].flat()));
      dispatch(updateZoom([polygonLocations?.flat(), circularLocations].flat()));
    }

    setFilteredRow(params);
    setIsOpen('Update Geofence');
    setCardOpen(false);
    setRow(data);
  };
  return { isUpdate, onUpdate, setIsUpdate };
};
